import { createElementBlock as t, openBlock as r, createElementVNode as e } from "vue";
import { _ as o } from "./main-DQQ1cljm.js";
const l = {};
function n(c, i) {
  return r(), t("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
      fill: "var(--red)"
    }),
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.5 9.50001L7.5 4.5H8.50002V9.50001H7.5Z",
      fill: "white"
    }),
    e("path", {
      d: "M7.5 10.5H8.50002V11.5L7.5 11.5V10.5Z",
      fill: "white"
    })
  ]);
}
const a = /* @__PURE__ */ o(l, [["render", n]]);
export {
  a as default
};
